import type { FC } from 'react';
import { TableColumn } from '../../../types/reports';

interface Props {
  className?: string;
  columns: TableColumn[];
}

const TableHeader: FC<Props> = ({ className, columns }) => {
  return (
    <thead className={className}>
      <tr>
        {columns.map((column, index) => (
          <th key={index} style={{ width: column.width }}>
            {column.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};
TableHeader.displayName = 'TableHeader';

export default TableHeader;
